const getURLParam = key => {
  const params = new URLSearchParams(window.location.search);
  return params.get(key);
};

const deleteOrSetURLParam = (key, value) => {
  const {
    history,
    location: { search, pathname }
  } = window;
  const params = new URLSearchParams(search);
  if (value == null) {
    params.delete(key);
  } else {
    params.set(key, value);
  }
  history.replaceState({}, '', `${pathname}?${params.toString()}`);
};

const validateRequiredParams = (urlParams, requiredParams) => {
  const missingParams = requiredParams.filter(param => {
    const value = urlParams.get(param);
    return value === null || value === '';
  });

  if (missingParams.length > 0) {
    throw new Error(`Missing URL param(s): ${missingParams.join(', ')}`);
  }
};

export { getURLParam, deleteOrSetURLParam, validateRequiredParams };
